import React from 'react'
import { Link } from 'react-router-dom'

const networks = {
  Facebook: 'https://www.facebook.com/paolomantini/',
  Instagram: 'https://www.instagram.com/paolomantini/',
  SoundCloud: 'https://soundcloud.com/paolo-mantini',
  Linkedin: 'https://www.linkedin.com/in/paolomantini/',
  ResidentAdvisor: 'https://www.residentadvisor.net/dj/paolomantini/',
}

const Footer = () =>
  <footer>
    <section className="container">
      <aside>
        <Link to="/">© {new Date().getFullYear()} {ROOT_DATA_NEW.generalInfo.name}.</Link>
      </aside>
      <aside className="link-border">
        {Object.keys(ROOT_DATA_NEW.social).map((network, i) =>
          <Link to={ROOT_DATA_NEW.social[network]} target="_blank" key={i}>{network}</Link>
        )}
      </aside>
    </section>
  </footer>

export default Footer



// WEBPACK FOOTER //
// src/javascripts/components/Footer.js